var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGreenSilhouette = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4992 8.54171C23.7984 8.54171 26.4784 11.2217 26.4784 14.5209C26.4784 17.8201 23.7984 20.5 20.4992 20.5C17.2 20.5 14.52 17.8201 14.52 14.5209C14.52 11.2217 17.2 8.54171 20.4992 8.54171ZM27.3325 25.625C30.1566 25.625 32.4575 27.926 32.4575 30.75V32.4584H8.54085V30.75C8.54085 27.926 10.8418 25.625 13.6659 25.625C18.2036 25.625 17.2587 26.4792 20.4992 26.4792C23.7504 26.4792 22.7894 25.625 27.3325 25.625ZM20.4992 6.83337C16.255 6.83337 12.8117 10.2767 12.8117 14.5209C12.8117 18.765 16.255 22.2084 20.4992 22.2084C24.7433 22.2084 28.1867 18.765 28.1867 14.5209C28.1867 10.2767 24.7433 6.83337 20.4992 6.83337ZM27.3325 23.9167C22.3997 23.9167 23.5422 24.7709 20.4992 24.7709C17.4669 24.7709 18.5933 23.9167 13.6659 23.9167C9.8915 23.9167 6.83252 26.9757 6.83252 30.75V32.4584C6.83252 33.4033 7.59593 34.1667 8.54085 34.1667H32.4575C33.4024 34.1667 34.1659 33.4033 34.1659 32.4584V30.75C34.1659 26.9757 31.1069 23.9167 27.3325 23.9167Z",
    fill: "#00EC25"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGreenSilhouette);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/GreenSilhouette.0249f0d17cf4b33bc950df47dbf985b1.svg";